module.exports = __webpack_public_path__ + "media/images/regions/thumbnails/middle_east_and_north_africa-47c81dbe1878575412b04d3d16d8f796.png";